var Fav = function(gallery){
    var _addFav,
         _addFavClick,
        _removeFav,
        _listFav,
        _cKey = 'fab',
        _activeFavClass = 'active',
        _favButtSelector = '.v-icon.heart-icon';


    _addFav = function(cStr){
        var oldCookie = Cookies.get(_cKey) || "";

        if(oldCookie.indexOf(cStr) >= 0){
            return;
        }

        if(oldCookie != ""){
            cStr = oldCookie + cStr;
        }

        if(oldCookie.indexOf(cStr) < -1){
            Cookies.set(_cKey, cStr);
        }

        Cookies.set(_cKey, cStr);

        // console.log('_addFav:', cStr);
    };

    _addFavClick = function(e){
        var $el = $(this),
            pageNum = gallery.getCurrentIndex(),
            oldCookie = Cookies.get(_cKey) || "",
            cStr = _generateCookieStr(brochureId, pageNum);

        if($el.hasClass(_activeFavClass)){
            _removeFav(cStr);
        }else{
            _addFav(cStr);
        }

        $el.toggleClass(_activeFavClass).find('i').toggleClass('fa-heart fa-heart-o');
    };

    _removeFav = function(cStr){
        var oldCookie = Cookies.get(_cKey) || "",
            cInx = oldCookie.indexOf(cStr),
            newCookie;

        if(oldCookie != ""){
            cStr = "".concat(oldCookie.slice(0, cInx), oldCookie.slice(cInx + cStr.length));
        }else{
            cStr = "";
        }

        Cookies.set(_cKey, cStr);
    };

    _generateCookieStr = function(brochureId, pageNum){
            return brochureId + '#';// + pageNum + '|';
    };

    _initFavState = function(){
        var oldCookie = Cookies.get(_cKey) || "",
            pageNum = gallery.getCurrentIndex(),
            cStr = _generateCookieStr(brochureId, pageNum),
            cInx = oldCookie.indexOf(cStr);

        if(cInx > -1){
            $(_favButtSelector).toggleClass(_activeFavClass).find('i').toggleClass('fa-heart fa-heart-o');
        }
    };

    _clearFavs = function(){

    };

    _events = function(){
        _initFavState();

        $(document).on('click', '.v-icon.heart-icon', _addFavClick);
    };

    this.events = _events;
    this.addFav = _addFav;
    this.removeFav = _removeFav;
    this.initFavState = _initFavState;
    this.clearFavs = _clearFavs;
};